import CompassButton from './CompassButton';

export default CompassButton;
